import { render, staticRenderFns } from "./QACoder.vue?vue&type=template&id=766c121c"
import script from "./QACoder.vue?vue&type=script&lang=js"
export * from "./QACoder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports